module.exports = __webpack_public_path__ + "static/media/the-game-cricket-2024.701b8282.png";